import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Star, Map, BarChart3, Mic } from "lucide-react";
import { api, setChildId } from "../lib/api";
import { useAuth, login } from "../context/AuthContext";
import { SiteLayout } from "../components/site/SiteLayout";
import { Avatar } from "../components/Avatar";
import { ParentGate } from "../components/ParentGate";

const Action = ({ icon: Icon, title, text, onClick, testid, color }) => (
  <button data-testid={testid} onClick={onClick} className="scroll-card p-6 text-left hover:-translate-y-1 transition-transform">
    <div className={`w-12 h-12 rounded-2xl flex items-center justify-center text-white ${color}`}><Icon /></div>
    <div className="text-2xl font-black mt-4">{title}</div>
    <p className="text-stone-600 mt-1">{text}</p>
  </button>
);

export default function UserHub() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [kids, setKids] = useState([]);
  const [total, setTotal] = useState(0);
  useEffect(() => { api.get("/public/stories").then(({ data }) => setTotal(data.length)).catch(() => {}); }, []);
  const [gateTo, setGateTo] = useState(null);
  useEffect(() => { if (user) api.get("/children").then(({ data }) => setKids(data)); }, [user]);

  return (
    <SiteLayout>
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-14 font-serif-tc" data-testid="user-hub-page">
        <h1 className="text-4xl sm:text-5xl font-black text-[var(--vermilion)]">我的學習中心</h1>
        {!loading && !user && (
          <div className="scroll-card p-10 mt-8 text-center" data-testid="user-hub-login">
            <p className="text-xl text-stone-700">請先登入家長帳號，就能看到孩子的學習進度。</p>
            <button data-testid="user-hub-login-btn" onClick={login} className="kid-btn mt-6 px-10 bg-[var(--vermilion)] text-white text-xl">家長登入</button>
          </div>
        )}
        {user && (
          <>
            <p className="text-lg text-stone-700 mt-3">歡迎回來，{user.name}！</p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-8" data-testid="user-hub-children">
              {kids.map((k) => (
                <button key={k.child_id} data-testid={`hub-child-${k.child_id}`} onClick={() => { setChildId(k.child_id); nav("/halls"); }} className="scroll-card p-5 flex items-center gap-4 text-left hover:-translate-y-1 transition-transform">
                  <span className="text-5xl w-14 h-14 inline-flex items-center justify-center"><Avatar value={k.avatar} /></span>
                  <span>
                    <span className="block text-2xl font-black">{k.nickname}</span>
                    <span className="flex items-center gap-1 text-amber-600 font-bold"><Star size={16} fill="currentColor" /> {k.stars}・完成 {k.completed_lessons.length}/{total} 課</span>
                  </span>
                </button>
              ))}
              {!kids.length && <p className="text-stone-500 col-span-full">還沒有學習者，請到「進入冒險」新增孩子的暱稱。</p>}
            </div>
            <div className="grid md:grid-cols-3 gap-5 mt-10">
              <Action testid="hub-adventure-btn" icon={Map} color="bg-[var(--jade)]" title="進入冒險" text="選擇孩子，打開故事地圖。" onClick={() => nav("/profiles")} />
              <Action testid="hub-report-btn" icon={BarChart3} color="bg-[var(--vermilion)]" title="學習報告" text="注音、國字精熟度與建議複習。" onClick={() => setGateTo("/parent")} />
              <Action testid="hub-recordings-btn" icon={Mic} color="bg-amber-600" title="家長錄音室" text="親自錄音，取代電腦發音。" onClick={() => setGateTo("/recordings")} />
            </div>
          </>
        )}
      </div>
      <ParentGate open={!!gateTo} onOpenChange={(o) => !o && setGateTo(null)} onPass={() => nav(gateTo)} />
    </SiteLayout>
  );
}
